/**
 * Created by mozartdiniz on 12/2/14.
 */

Greenmile.Survey.Sidebar.Generic = (function () {

    function Generic () {

        this.questionDescriptorSelector = "#QuestionDescription";
        this.templateID = 'SurveyGenericContainerTemplate';

        this.getQuestionDescriptionElement = function () {
            return document.querySelector(this.questionDescriptorSelector);
        };

        this.getQuestionDefaultValueElement = function () {
            return document.querySelector('.SingleRowHeader #defaultValue');
        };

        this.addDefaultValueField = function (question, type, element) {

            var name = (question ? question.id : '');
            var header = document.querySelector('#SurveyLinkForm .SingleRowHeader');

            const fieldType = type || this.fieldType || this.jsonType;
            var field = new Monet.UI.Fields.Render({
                type: fieldType,
                id: 'SurveyDefaultAnswer',
                name: name
            }, 'Survey');

            field = field.render();
            field.rootEl.className += ` surveyDefaultAnswer ${fieldType}FieldType`
            header.appendChild(field.rootEl);
            this.fieldDefaultAnswer = field;

            if(type && type == 'TEXT' && question){
                const answers = question.surveyQuestionDomain;

                if(answers) {
                    answers.map(answer => {
                        element.innerHTML += `${answer.value}\n`;
                    })
                }
                else {
                    element.innerHTML = '';
                }

            }
        };

        //This is a callback. You should implemented it if you want show something diferent of SurveyGenericContainerTemplate.
        this.didRenderTemplate = function (question) {
            if (!this.hideDefaultAnswer) {
                this.addDefaultValueField(question);
            }
        };

        /**
         * This is like a setValue of update fields
         *
         * @param question
         */
        this.prepareForUpdate = function (question) {

            var questionElement = this.getQuestionDescriptionElement();
            questionElement.value = question.question;
            if (this.fieldDefaultAnswer) {
                this.fieldDefaultAnswer.setValue(question.defaultAnswer || '');
            }

        };

        /**
         * This is used when user click on Save button
         * @returns {{questionText: *, questionType: *}}
         */
        this.serializeInput = function () {

            const questionElement = this.getQuestionDescriptionElement();
            const hiddenType = document.getElementsByName('questionType')[0];
            const defaultValue = this.fieldDefaultAnswer ? this.fieldDefaultAnswer.getFilterValue() : null;
            const result = {
                questionText: questionElement.value,
                questionType: hiddenType.value
            };
            
            if (defaultValue) {
                result.defaultAnswer = defaultValue.toString();
            }

            return result;
        };

        /**
         * This is used to render the preview field on survey form
         *
         * @param questionContent
         * @param input
         */
        this.addQuestionContent = function (questionContent, input) {

            var newQuestionDescription = questionContent.querySelector('.newQuestionDescription'),
                answerContent          = questionContent.querySelector('.answerContent'),
                questionText           = input.questionText,
                renderedInput;

            answerContent.innerHTML = '';

            newQuestionDescription.title = questionText;
            newQuestionDescription.innerHTML = questionText;

            questionContent.setAttribute('questionType', input.questionType);
            renderedInput = this.getPreviewContent(input.questionData);

            if (!this.hideAnswerInput) {
                answerContent.appendChild(renderedInput);
            }

        };

        /**
         * This is used to render the field that will be shown on preview form.
         * It is called by  function above (addQuestionContent)
         *
         * @param question_id
         * @returns {*}
         */
        this.getPreviewContent = function (question) {
            var type = this.fieldType || this.jsonType;
            var field = new Monet.UI.Fields.Render({
                type: type,
                name: question.id
            }, 'Survey');

            field = field.render();
            field.setValue(question.defaultAnswer);

            return field.rootEl;
        };
    }

    return Generic;

}());
